module.exports = __webpack_public_path__ + "img/chengyun77.ce71884d.png";